<!-- template for pages without navigation; eg. login and sign up-->
<template>
  <div>
    <img
      src="/pictures/logo.svg"
      alt="Teachino Logo"
      class="absolute top-4 left-4 h-8"
    />
    <div
      class="flex h-screen flex-col bg-neutral-200 pt-16 sm:justify-center sm:px-6 lg:px-8"
      data-test="PageFullModalLayout"
    >
      <div
        class="h-full overflow-y-auto sm:mx-auto sm:h-auto sm:w-full sm:max-w-lg"
      >
        <div
          class="h-full bg-white-500 py-8 px-4 shadow sm:h-auto sm:rounded-lg sm:px-10"
        >
          <div v-if="showClose" class="-mb-12 flex flex-row-reverse">
            <a data-test="PageFullModalLayout-Button-Close" @click="close">
              <TIcon
                name="close"
                class="h-8 w-8 rounded-full p-1 text-gray-600 hover:bg-gray-100"
              />
            </a>
          </div>
          <div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $router } = useNuxtApp();

const showClose = !!$router.currentRoute.value.query.close;

function close() {
  if ($router.currentRoute.value.query.close) {
    navigateTo($router.currentRoute.value.query.close);
  }
}
</script>
